
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DealerAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CURRENT"},{"kind":"EnumValue","value":"DEALER"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DealerDetail"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DealerAddressDetail"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginateAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dealers"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"addresses"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"plannedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DealerAuditStatistics"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginateInspections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dealers"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"addresses"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"plannedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DealerInspectionStatistics"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":740}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/dealers/DealerDetail.gql\"\n#import \"@/graphql/fragments/dealers/DealerAddressDetail.gql\"\n#import \"@/graphql/fragments/dealers/DealerAuditStatistics.gql\"\n#import \"@/graphql/fragments/dealers/DealerInspectionStatistics.gql\"\n\nquery DealerAddress($id: ID!, $addressId: ID!, $date: DateRange) {\n  entity(id: $id, entityTypes: [CURRENT, DEALER]) {\n    ...DealerDetail\n  }\n\n  address(id: $addressId) {\n    ...DealerAddressDetail\n  }\n\n  paginateAudits(dealers: [$id], addresses: [$addressId], plannedAt: $date) {\n    statistics {\n      ...DealerAuditStatistics\n    }\n  }\n\n  paginateInspections(dealers: [$id], addresses: [$addressId], plannedAt: $date) {\n    statistics {\n      ...DealerInspectionStatistics\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/dealers/DealerDetail.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/dealers/DealerAddressDetail.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/dealers/DealerAuditStatistics.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/dealers/DealerInspectionStatistics.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["DealerAddress"] = oneQuery(doc, "DealerAddress");
        
